import { createStore } from 'jotai'
import { createContext, ReactNode, useContext, useMemo } from 'react'

/**
 * Use this store for org-level state, such as branding and assets.
 */

export const OrgStoreContext = createContext<ReturnType<typeof createStore> | null>(null)

export function OrgStoreProvider(
	{
		children,
		orgId,
	}: {
		children: ReactNode
		orgId: string
	},
) {
	// be sure to generate a new store whenever orgId changes.
	const store = useMemo(() => createStore(), [orgId])

	return (
		<OrgStoreContext.Provider value={store}>
			{children}
		</OrgStoreContext.Provider>
	)
}

export function useOrgStore() {
	const store = useContext(OrgStoreContext)
	if (!store) {
		throw new Error('OrgStoreContext not found')
	}
	return store
}
